/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CostComponent
 */
export interface CostComponent {
    /**
     * Identifier for the component
     * @type {string}
     * @memberof CostComponent
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CostComponent
     */
    version: string;
    /**
     * Amount of the component.
     * @type {any}
     * @memberof CostComponent
     */
    value: any;
    /**
     * Common name of the component
     * @type {string}
     * @memberof CostComponent
     */
    name: string;
    /**
     * Component identifier that amount is based on
     * @type {string}
     * @memberof CostComponent
     */
    base?: string;
    /**
     * Whether the component's amount is collected between customer and program
     * @type {boolean}
     * @memberof CostComponent
     */
    intermediate: boolean;
    /**
     * ID of the account the amount is sent to.
     * @type {string}
     * @memberof CostComponent
     */
    recipient?: string;
    /**
     * Bucket that the component belongs to
     * @type {string}
     * @memberof CostComponent
     */
    bucket?: string;
    /**
     * Type of the account the component is paid by
     * @type {string}
     * @memberof CostComponent
     */
    payer?: string;
}

export function CostComponentFromJSON(json: any): CostComponent {
    return CostComponentFromJSONTyped(json, false);
}

export function CostComponentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostComponent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'version': json['version'],
        'value': json['value'],
        'name': json['name'],
        'base': !exists(json, 'base') ? undefined : json['base'],
        'intermediate': json['intermediate'],
        'recipient': !exists(json, 'recipient') ? undefined : json['recipient'],
        'bucket': !exists(json, 'bucket') ? undefined : json['bucket'],
        'payer': !exists(json, 'payer') ? undefined : json['payer'],
    };
}

export function CostComponentToJSON(value?: CostComponent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'version': value.version,
        'value': value.value,
        'name': value.name,
        'base': value.base,
        'intermediate': value.intermediate,
        'recipient': value.recipient,
        'bucket': value.bucket,
        'payer': value.payer,
    };
}

